import React, { useState } from 'react'
import { Button, Flex, Grid, Input, InputGroup, InputLeftAddon, Text, useToast } from '@chakra-ui/react'

import { runVerificaAutenticacao, VerificaNotaExixtente } from '../../../services/api'
import { useEffect } from 'react'
import { user } from '../../../helpers/user'
import { PreviewComissao } from './PreviewComissao'
import { PedidoAprovado } from './PedidoAprovado'

const PreviewPropostaOrcamento = () => {
  const [formValues, setFormValues] = useState({
    orcamento: '',
    pedido: '',
    aprovado: '',
    liberacao: '',
  })

  const toast = useToast()

  function closeAll() {
    toast.closeAll()
  }

  useEffect(() => {
    runVerificaAutenticacao()
  }, [])

  const getBoletoOrcamento = async () => {
    if (formValues === '' || formValues === undefined || formValues === null) {
      toast(
        {
          position: 'top',
          title: 'Campo vazio!',
          description: 'Preencha o campo para visualizar a nota.',
          status: 'error',
          duration: 4000,
          isClosable: true,
        },
        closeAll()
      )
    } else {
      try {
        const param = {
          numero_nota: formValues.orcamento,
        }
        const response = await VerificaNotaExixtente.post('', param)
        const data = response.data

        if (data.message) {
          window.open(`${process.env.REACT_APP_BASE_URL}/site/v2/orcamento/visualiza-pdf-sankhya/${data.message}`)

          //limpar o campo de busca
        } else {
          toast(
            {
              position: 'top',
              title: 'Erro ao procurar nota!',
              description: `Nota ${formValues} inválido ou inexistente.`,
              status: 'error',
              duration: 4000,
              isClosable: true,
            },
            closeAll()
          )
        }
      } catch (error) {
        console.log(Object.keys(error), error.message)
      }
    }

    setFormValues({
      orcamento: '',
      pedido: '',
      aprovado: '',
    })
  }
  // 159488 , 159485 , 159414 , 159330

  async function gerarPdfPedido() {
    if (formValues === '' || formValues === undefined || formValues === null) {
      toast(
        {
          position: 'top',
          title: 'Campo vazio!',
          description: 'Preencha o campo para visualizar a nota.',
          status: 'error',
          duration: 4000,
          isClosable: true,
        },
        closeAll()
      )

      return
    }

    if (formValues.pedido) {
      window.open(`${process.env.REACT_APP_BASE_URL}/site/v2/orcamento/visualiza-pdf-pre-pagamento/${formValues.pedido}`)

      setFormValues({ ...formValues, pedido: '' })
    } else {
      toast(
        {
          position: 'top',
          title: 'Erro ao procurar nota!',
          description: `Nota ${formValues} inválido ou inexistente.`,
          status: 'error',
          duration: 4000,
          isClosable: true,
        },
        closeAll()
      )
    }
  }

  const [loadingSolicitarLiberacao, setLoadingSolicitarLiberacao] = useState(false)

  async function SolicitarLiberacao() {
    try {
      setLoadingSolicitarLiberacao(true)
      window.open(`${process.env.REACT_APP_BASE_URL}/site/v2/liberacao-pedido/enviar-liberacao-pedido/${formValues.aprovado}`)
    } catch (error) {
      console.log(error)
      setLoadingSolicitarLiberacao(false)
    }

    setLoadingSolicitarLiberacao(false)
  }

  return (
    <>
      <Grid templateColumns="repeat(4, 1fr)" gap={10} mx="10">
        <Flex flexDirection="column" gap={2}>
          <Text fontSize="2xl" fontWeight="bold" bg="#5FAAD9" color="white" py={2} textAlign="center">
            Preview Proposta/Orçamento
          </Text>
          <InputGroup fontFamily="Akrobat" size="sm">
            <InputLeftAddon bgColor="#5FAAD9" color="white" children="Nº ÚNICO:" height="100%" />
            <Input
              onFocus
              focusBorderColor="#5FAAD9"
              bgColor="white"
              autoFocus
              placeholder="Digite o número..."
              type="number"
              onChange={(e) => setFormValues({ formValues, orcamento: e.target.value })}
              value={formValues.orcamento}
              onKeyPress={(e) => (e.key === 'Enter' ? getBoletoOrcamento() : null)}
              size="lg"
            />
          </InputGroup>
          <Button bgColor="gray.200" _hover={{ filter: 'brightness(0.9)' }} onClick={() => getBoletoOrcamento()} color="#5FAAD9" size="lg">
            {' '}
            Filtrar{' '}
          </Button>
        </Flex>

        <Flex flexDirection="column" gap={2}>
          <Text fontSize="2xl" fontWeight="bold" bg="#8a8a8a" color="white" py={2} textAlign="center">
            Preview Proposta/Pedido
          </Text>
          <InputGroup fontFamily="Akrobat" size="sm">
            <InputLeftAddon bgColor="#8a8a8a" color="white" children="Nº ÚNICO:" height="100%" />
            <Input
              onFocus
              focusBorderColor="#8a8a8a"
              bgColor="white"
              autoFocus
              placeholder="Digite o número..."
              type="number"
              size="lg"
              onChange={(e) => setFormValues({ ...formValues, pedido: e.target.value })}
              value={formValues.pedido}
              onKeyPress={(e) => (e.key === 'Enter' ? gerarPdfPedido() : null)}
            />
          </InputGroup>
          <Flex gap={2} flexDir="column">
            <Button bgColor="gray.200" _hover={{ filter: 'brightness(0.9)' }} onClick={() => gerarPdfPedido()} color="#8a8a8a" size="lg">
              Filtrar{' '}
            </Button>
          </Flex>
        </Flex>

        {user?.isAdmin && (
          <Flex flexDirection="column" gap={2}>
            <Text fontSize="2xl" fontWeight="bold" bg="#d9985f" color="white" py={2} textAlign="center">
              Liberação Pedido
            </Text>
            <InputGroup fontFamily="Akrobat" size="sm">
              <InputLeftAddon bgColor="#d9985f" color="white" children="Nº ÚNICO:" height="100%" />
              <Input
                onFocus
                focusBorderColor="#d9985f"
                bgColor="white"
                autoFocus
                placeholder="Digite o número..."
                type="number"
                onChange={(e) => setFormValues({ formValues, liberacao: e.target.value })}
                value={formValues.liberacao}
                onKeyPress={(e) => (e.key === 'Enter' ? getBoletoOrcamento() : null)}
                size="lg"
              />
            </InputGroup>
            <Button
              bgColor="gray.200"
              _hover={{ filter: 'brightness(0.9)' }}
              color="#d9985f"
              size="lg"
              onClick={() => {
                window.open(`${process.env.REACT_APP_BASE_URL}/site/v2/liberacao-pedido/enviar-liberacao-pedido/${formValues.liberacao}/0`)
              }}
            >
              Liberar
            </Button>
          </Flex>
        )}

        <PedidoAprovado />

        <PreviewComissao />
      </Grid>
    </>
  )
}

export default PreviewPropostaOrcamento
